import { render } from "./OptionsEditor.vue?vue&type=template&id=1320ee06&scoped=true&ts=true"
import script from "./OptionsEditor.vue?vue&type=script&lang=ts"
export * from "./OptionsEditor.vue?vue&type=script&lang=ts"

import "./OptionsEditor.vue?vue&type=style&index=0&id=1320ee06&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1320ee06"]])

export default __exports__